<template>
<div v-if="controller.row_data.name != undefined" class="col-12 pt-2">
        <div class="nameProduct mt-2 mb-3"><hr></div>

        <div class="row">

            <div  class=" col col-md-6 col-sm-12 imagesProduct " style="background-color:#fff;padding:30px;" >

                 <zoom-on-hover  :img-zoom="mainImageB64" :scale="1.5"  :img-normal="mainImageB64"/>

                <VueSlickCarousel v-if="allImagesB64.length > 0" class="slickthumb" style="width: 100%;margin-top:15px; padding: 10px;"
                    ref="c2"
                    :slidesToShow="4"
                    arrows: true,
                >
                    <div  v-for="(thumbs, i)  in imagesProducts" v-bind:key="thumbs.id" v-on:click="changeImage(i)" >  <img :src="allImagesB64[i]"/> </div>
                </VueSlickCarousel>

                <p></p>

                <div class="col col-md-12 mt-6 descpcort" v-html="controller.row_data.more.descripcion_corta"></div>
                <div class="ml-2 pl-2 mt-4" style="text-align: left" v-if="controller.row_data.more.mainFeatures && controller.row_data.more.mainFeatures.length >0">
                    <div class="col-md-12" style="font-size:14px; font-weight: bold; text-align:left">Características Principales</div>
                    <ul class="ml-4">
                        <li v-for="feature in controller.row_data.more.mainFeatures" v-bind:key="feature">{{ feature }}</li>
                    </ul>
                </div>
            </div>

            <div class=" col-md-6 col-sm-12">

                <div class="border border-secondary pt-2 pl-4 cont-product" >
                    <div class="nameProduct mt-2 mb-3">{{controller.row_data.name}}</div>
                    <p class="clasificacion1">
                        <input :id="'radio1'+controller.row_data.id" type="radio" v-model="promQualificaton" :name="'estrellas'+controller.row_data.id" value="5" disabled>
                        <label :for="'radio1'+controller.row_data.id">★</label>
                        <input :id="'radio2'+controller.row_data.id" type="radio" v-model="promQualificaton"  :name="'estrellas'+controller.row_data.id" value="4" disabled>
                        <label :for="'radio2'+controller.row_data.id">★</label>
                        <input :id="'radio3'+controller.row_data.id" type="radio" v-model="promQualificaton"  :name="'estrellas'+controller.row_data.id" value="3" disabled>
                        <label :for="'radio3'+controller.row_data.id">★</label>
                        <input :id="'radio4'+controller.row_data.id" type="radio" v-model="promQualificaton"  :name="'estrellas'+controller.row_data.id" value="2" disabled>
                        <label :for="'radio4'+controller.row_data.id">★</label>
                        <input :id="'radio5'+controller.row_data.id" type="radio" v-model="promQualificaton"  :name="'estrellas'+controller.row_data.id" value="1" disabled>
                        <label :for="'radio5'+controller.row_data.id">★</label>
                    </p>

                    <div class="text-secondary row col-md-12">Producto &nbsp; <span v-if="controller.row_data.balance > 0"> disponible</span>  <span v-if="controller.row_data.balance <= 0"> no disponible</span></div>
                    <div class="text-secondary row col-md-12">Codigo: {{controller.row_data.sku}}</div>
                    <div class="text-secondary mt-4 row col-md-12"><span class="valueBeforeTittle"> Precio antes:&nbsp; </span>  <span class="valueBefore">  ${{controller.row_data.starting_price | numFormat }}</span> </div>
                    <div class="row col-md-12"><span class="valueTittle">Llévalo por:&nbsp; </span>  <span class="valueProduct"> ${{controller.row_data.total_price | numFormat }}</span></div>

                    <div class="row col-md-12">

                        <form id="app" method="post">

                            <p class="error_list" v-if="errors.length">
                            <ul>
                                <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
                            </ul>
                            </p>

                            <div class="d-flex d-flex">
                                <div class=" bd-highlight mr-3">Cantidad:</div>
                                <div class="bd-highlight">
                                    <select id="quantity" name="quantity" v-model="quantity" style="width:80px; border-style: solid;-webkit-appearance:inner-spin-button;">
                                        <option v-for="quantity in quantitys" v-bind:key="quantity+''">{{quantity}}</option>
                                    </select>
                                </div>
                            </div>

                        </form>
                    </div>
                    <div class="row col-12" >Unidades disponibles: {{controller.row_data.balance}}</div>

                    <div class="form-row ">
                        <div class="col-md-10 col-xs-12 pl-4">
                            <button v-if="controller.row_data.balance > 0" type="button" v-on:click="checkForm()"  class="btn btn-buy mt-3 btn-circle  btn-block" >Comprar</button>
                        </div>

                        <div class="text-secondary mt-3">
                            Pensamos en tu bienestar y comodidad, por eso, todas las compras </br>
                            que realices en nuestra tienda seran entregadas en tu casa.
                        </div>
                        <div class="pt-3 text-secondary pb-4">
                            <h5>¡Para hacer de tus deseos una realidad!</h5>
                        </div>
                    </div>
            </div>
        </div>
    </div>

    <div>
        <div class="row">
            <div class="col col-md-4 features">
                <div class="col mt-4 text-white text-center pt-2 pb-2 mb-3 bgTitleSeccion"><h5>Características</h5></div>

                <ul>
                    <li  v-for="arrCarac in controller.row_data.more.caracteristicas" v-bind:key="arrCarac.prop" >
                        <span v-if="arrCarac.prop" >{{ arrCarac.prop }} : {{ arrCarac.value}}</span>
                     </li>
                </ul>
            </div>
            <div class="col-md-8">
                <div class="col mt-4 text-white text-center pt-2 pb-2 mb-3 bgTitleSeccion"><h5>Complementa tu Compra</h5></div>

                <VueSlickCarousel v-if="relatedProducts.length > 0"  v-bind="settings" class="carousel">
                    <div class="contProduct" v-for="related in relatedProducts" v-bind:key="related.name">
                        <div class="product-name">{{ related.name }}</div>

                        <div class="image_container">
                            <img width = "200" v-if="related.images[0]" style="width:100%" class="img-responsive" :src="'https://ikommi-images.nyc3.digitaloceanspaces.com/' + dodir + '/' + related.images[0].id + '_400.png'"/>
                        </div>
                        <div class="row col-md-12 nopadding">
                            <div class="col-md-3 nopadding">
                                <div class="discount ml-2">
                                    {{ Math.round(related.discount) }}%
                                    <div class="dcto">Dcto</div>

                                </div>
                            </div>
                            <div class="col-md-9 total_price mb-1">
                                <div class="value_before">Antes:
                                    <span class="price_before"> ${{ related.starting_price | numFormat }}</span></div>
                                <div class="total_product mt-1">Ahora: <span>${{related.total_price | numFormat }}</span> </div>
                            </div>
                        </div>
                        <div class="row divBtnProducts nopadding">
                            <div class="col col-md-6 nopadding"><button type="button" class="btn-products btn bvp mr-1" v-on:click="goProduct(related)" >Ver Producto</button> </div>
                        </div>
                    </div>
                </VueSlickCarousel>
            </div>
        </div>

        <div class="col mt-4 text-white text-center pt-2 pb-2 mb-3 bgTitleSeccion"><h5>Descripción</h5></div>
        <div class="col col-md-12"  v-html="controller.row_data.more.descripcion"></div>

        <!-- popup botones-->

        <div class="modal fade" id="buttonsModal" tabindex="-1" role="dialog" aria-labelledby="buttonsModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div><h3 class="color_orange text-center">Tu producto ha sido agregado <br/> al carrito de compras</h3></div>
                        <center>
                            <div class="col-md-6 mb-2 mt-1"><button type="button"  class="btn btn-block btn-yellow" border-0 v-on:click="direct('/cart')">Ir al Carrito</button></div>
                            <div class="col-md-6"><button type="button"  v-on:click="direct('/index')" class="btn btn-block btn-blue-skin" border-0  >Agregar más productos</button></div>
                        </center>
                    </div>
                    <div class="modal-footer">

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    require('numeral/locales/es');
    numeral.locale('es');
    import numFormat from 'vue-filter-number-format';
    import {default_controller} from '../helpers';
    import numeral from 'numeral';
    import VueSlickCarousel from 'vue-slick-carousel';
    import 'vue-slick-carousel/dist/vue-slick-carousel.css';
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
    import Vue from 'vue';
    import ZoomOnHover from "vue-zoom-on-hover";
    Vue.use(ZoomOnHover);
    export default {
        name: 'DetailProduct',
        props: ['productId',  "client", "dodir"],
        components: { VueSlickCarousel },

        filters : {
            numFormat: numFormat(numeral)
        },

        data: ()=>({
            controller : default_controller,
             errors:[],
            id : 0,
            identification: 0,
            productCart: [],
            mainImageB64 : "data:image/png;base64,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",
            allImagesB64: [],
            quantity: 1,
            idBuy: 123,
            writtenCode: 0,
            codeVerification: 0,
            localId : 0,
            quantitys: [1,2,3,4,5,6,7,8,9],
            caracteristicas: {},
            description: [],
            relatedProducts: {},
            imagesProducts: {},
            productInitial : 0,
            settings: {
                "focusOnSelect": true,
                "infinite": true,
                "speed": 500,
                "slidesToShow": 3,
            },
            imageRelatedProduct: {},
            promQualificaton:0
        }),
        methods: {
            getImageData(id,size) {
                const url = `https://ikommi-images.nyc3.digitaloceanspaces.com/${this.dodir}/${id}_${size}.png`;
                return axios
                    .get(url, {
                    responseType: 'arraybuffer'
                })
                .then(response => Buffer.from(response.data, 'binary').toString('base64'))
            },
            getLocalImage(id, size){
                const url = 'https://faas-nyc1-2ef2e6cc.doserverless.co/api/v1/web/fn-e60a00ff-1981-4d14-ae1f-b23ccc3f60dd/images/resize-upload?size='+size+'&id='+ id +'&dir='  + this.dodir;
                return axios
                    .get(url, {
                    responseType: 'arraybuffer'
                })
                .then(response => Buffer.from(response.data, 'binary').toString('base64'))
            },
            checkForm:function(e) {
                this.errors = [];
                if(this.quantity <= 0) {
                    this.errors.push("La cantidad debe ser mayor a cero.");
                } else {
                    $('#buttonsModal').modal('show')
                    this.addToCart();
                }
            },
            direct: function (linkdirect) {
               window.location = "/" +this.client  +  linkdirect;
            },
            addToCart() {
                var totalPriceProduct = this.controller.row_data.total_price * this.quantity;

                if (window.localStorage.getItem('ProductCart') !== null) {
                     JSON.parse(localStorage.getItem('ProductCart')).forEach((value, index) => {
                        this.productCart = (JSON.parse(localStorage.getItem('ProductCart')));
                        this.localId++;
                    });
                    var product = {idLocal:this.localId+1, idProduct:this.controller.row_data.id, 'nameProduct':this.controller.row_data.name, quantity:this.quantity, valueProduct:this.controller.row_data.total_price,totalPriceProduct: totalPriceProduct }

                    this.productCart.push (product);
                } else {
                    var product = {idLocal:1, idProduct:this.controller.row_data.id, 'nameProduct':this.controller.row_data.name, quantity:this.quantity, valueProduct:this.controller.row_data.total_price,totalPriceProduct: totalPriceProduct }

                    this.productCart.push (product);
                }
                localStorage.setItem('ProductCart',JSON.stringify(this.productCart));
                /* axios.post('/add-to-cart', {
                    product_id: this.controller.row_data.id,
                    customer_ident: this.identification,
                    state:0

                }).then(response => {
                        console.log(this.identification, this.controller.row_data.id);
                        //this.quota = response.data.data;
                        console.log(response.data);
                    })
                    .catch(function (error) {
                        console.log(error);

                    }); */
            },

             getProduct (){
                this.controller.http.show(this.id);
                //console.log(this.controller.row_data);
            },
            goProduct(idProduct){
                axios.post('/created-view-product',{
                    productId: idProduct.id,
                })
                    .then(response => {
                        window.location = "/" + this.client + "/product/"+ idProduct.id + "/" + idProduct.slug + ".html";
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getRelatedProducts (){
                axios.post('/get-related-products', {
                    product_id: this.id
                }).then(response => {
                    this.relatedProducts = response.data.data;
                    //this.imageRelatedProduct = this.relatedProducts.images.find(imagep => imagep.tag == 'principal');
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            async getImagesProducts (){
                await axios.post('/get-images-products', {
                    product_id: this.id
                }).then(response => {
                    this.imagesProducts = response.data.data;
                    this.productInitial = this.imagesProducts[0].id;
                    this.getB64Images();
                })
                    .catch(function (error) {
                        console.log(error);

                    });
            },
             async getB64Images(){
                this.allImagesB64 =   await  Promise.all(this.imagesProducts.map( async  (item) =>  {
                    let all_image_content;
                    try{
                        all_image_content =  await this.getImageData(item.id.toString(), "");
                    }catch(err){
                        console.log(err);
                        all_image_content =  await this.getLocalImage(item.id.toString(), "");
                    }
                    return "data:image/jpeg;base64," +  all_image_content;
                }));

                // console.log(await this.allImagesB64[0].then());
            },
            changeImage(id){
                console.log("change to   " + id);
                this.productInitial = id;
                this.mainImageB64 = this.allImagesB64[id];
            },
            formatNumber(n) {
                n = String(n).replace(/\D/g, "");
                return n === '' ? n : Number(n).toLocaleString();
            },
            qualificationProduct() {
                axios.post('/get-qualification-product', {
                    product_id: this.id
                }).then(response => {
                    this.promQualificaton = response.data;
                })
                    .catch(function (error) {
                        console.log(error);

                    });
            }


        },

       async beforeMount() {
            console.log('Component mounted.')
            this.controller.init("products", [ ]);
            this.id = this.productId;
            this.getProduct();
            console.log('idproducto');
            console.log(this.id);
            this.getRelatedProducts();
            await this.getImagesProducts();
            this.qualificationProduct();

            let image_content;
            try{
                image_content =  await this.getImageData(this.productInitial.toString(), "");
            }catch(err){
                console.log(err);
                image_content = await this.getLocalImage(this.productInitial.toString(), "");
            }

            this.mainImageB64 =  "data:image/jpeg;base64," + image_content;




        },
    }
</script>
<style  rel="stylesheet" scoped>
.col-md-12{
    padding-top: 0;
    padding-bottom: 0;
}
.features {
    padding-left: 0;
    margin-left: 0;
}
.features ul{
    padding-left: 20px;
}
.slick-slide img[data-v-e4caeaf8] {
    display: inline-block;
}
.product-name {
    font-size: 14px;
}
.btn-products {
    font-size: 12px;
    width: 90px;
    padding: 5px 2px;
}
.contProduct {
    width: 98% !important;
    background-color: #9c9c960d;

}
.cont-product {
    height: fit-content;
}
 .imagesProduct {
     width: 90%;
     text-align: center;
 }
 .slickthumb img {
     max-height: 90px;
 }
 .slick-slide.slick-active{
     text-align: center;
 }
 .descpcort {
     margin-top: 50px;
     text-align: left;
 }
 .ctcompra {
     margin-top: 20px;
     color: #ff6f00;
     text-align: center;
     font-size: 20px;
 }
 .img.normal {
     max-height: 500px;
 }
input[type="radio"] {
    display: none;
}
.clasificacion, .clasificacion1 {
    direction: rtl;
    unicode-bidi: bidi-override;
    float: left;
    margin-bottom: 0;
}
.clasificacion label, .clasificacion1 label {
    font-size: 17px;
}
.clasificacion label:hover,
.clasificacion label:hover ~ label {
    color: orange;
}

input[type="radio"]:checked ~ label {
    color: orange;
}

</style>
